"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M14.728 1.012a2.194 2.194 0 0 1 1.969 2.182v1.551a1.097 1.097 0 1 1-2.193 0v-1.55h-9.53v17.61h9.53v-1.619a1.097 1.097 0 1 1 2.193 0v1.62l-.01.223a2.196 2.196 0 0 1-1.959 1.96l-.224.011h-9.53l-.224-.012a2.195 2.195 0 0 1-1.96-1.959l-.011-.223V3.194c0-1.136.864-2.07 1.97-2.182L4.974 1h9.53l.225.012Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M12.326 8.315a5.21 5.21 0 1 1 7.369 7.37 5.21 5.21 0 0 1-7.37-7.37Zm6.593.776a1.098 1.098 0 0 0-1.551 0l-1.358 1.357-1.357-1.357a1.098 1.098 0 0 0-1.552 1.552L14.46 12l-1.358 1.357a1.098 1.098 0 0 0 1.552 1.552l1.357-1.357 1.358 1.357a1.098 1.098 0 0 0 1.552-1.552L17.561 12l1.357-1.357a1.097 1.097 0 0 0 0-1.552Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M10.576 4.28a.66.66 0 0 1 0 1.32H8.9a.66.66 0 0 1 0-1.32h1.675Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};